export default __webpack_public_path__ + "static/media/lisa.e23c41f1.jpeg";